<div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-p-6">
  <loading class="tw-fixed tw-z-10 tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"></loading>
</div>

